import React, { useState, useEffect } from "react";
import { Input, Button, DatePicker, Alert, Empty, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import PromoCard from "../../BirthdayPromo/components/PromoCard";
import { useLookupMgbMember } from "../../BirthdayPromo/hooks/useFetch";

/**
 * แท็บเช็คโปรวันเกิดในหน้าจัดการเคส (customfield type = 7)
 *
 * เป็นเครื่องมือช่วยดูอย่างเดียว — ไม่ผูกกับ Form.Item ไม่เก็บค่าลงเคส
 * และไม่บังคับกรอก (ต่อให้ตั้ง required ที่หน้า customfield ก็ไม่บล็อกการส่งเคส)
 *
 * เบอร์เติมจากเคสให้อัตโนมัติ แต่แก้ได้ เผื่อลูกค้าแจ้งอีกเบอร์
 */
function BirthdayPromoCheck({ caseUserId }) {
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState(dayjs());
  const { mutateAsync: lookup, data, isLoading, error, reset } = useLookupMgbMember();

  // เคสเปลี่ยน (หรือเพิ่งกรอก User) → เติมเบอร์ใหม่ แล้วล้างผลเดิมทิ้ง
  useEffect(() => {
    setPhone(caseUserId ? String(caseUserId).replace(/\D/g, "") : "");
    reset();
  }, [caseUserId, reset]);

  const handleSearch = async () => {
    if (!/^\d{9,10}$/.test(phone)) return;
    try {
      await lookup({ phone, date: date ? date.format("YYYY-MM-DD") : undefined });
    } catch (e) {
      /* error แสดงผ่าน error ด้านล่างแล้ว */
    }
  };

  const result = data?.result;
  const promo = result?.promo;
  const member = result?.member;
  const phoneValid = /^\d{9,10}$/.test(phone);

  return (
    <div style={{ color: "#212121" }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <DatePicker
          value={date}
          onChange={setDate}
          format="DD/MM/YYYY"
          allowClear={false}
          style={{ width: 150 }}
        />
        <Input
          value={phone}
          onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
          onPressEnter={handleSearch}
          placeholder="เบอร์โทรลูกค้า"
          maxLength={10}
          style={{ width: 180 }}
        />
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={isLoading}
          disabled={!phoneValid}
        >
          เช็คโปรวันเกิด
        </Button>
      </div>

      {!caseUserId && (
        <Alert
          type="info"
          showIcon
          className="mb-3"
          message="เคสนี้ยังไม่มี User — กรอกเบอร์เองได้เลย"
        />
      )}

      {error && (
        <Alert
          type="error"
          showIcon
          className="mb-3"
          message={error?.response?.data?.message || "เช็คข้อมูลไม่สำเร็จ"}
        />
      )}

      {isLoading && (
        <div style={{ padding: 24, textAlign: "center" }}>
          <Spin tip="กำลังดึงข้อมูลจากระบบ MGB..." />
        </div>
      )}

      {!isLoading && result && !result.found && (
        <Empty description={`ไม่พบสมาชิกเบอร์ ${result.phone}`} />
      )}

      {!isLoading && promo && member && <PromoCard promo={promo} member={member} />}
    </div>
  );
}

export default BirthdayPromoCheck;
